var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.768 1.584-4.7 4.7L.234 3.451l.934-.933 1.9 1.9L6.834.65l.934.933Z",
    fill: "currentColor"
  })));
};
export { SvgCheck as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOCA3IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNy43Njc3MSAxLjU4NDIxTDMuMDY3NzEgNi4yODQyMUwwLjIzNDM3NSAzLjQ1MDg4TDEuMTY3NzEgMi41MTc1NUwzLjA2NzcxIDQuNDE3NTVMNi44MzQzNyAwLjY1MDg3OUw3Ljc2NzcxIDEuNTg0MjFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";